import { Trans } from 'react-i18next'
import { Box, Text, Badge, TooltipRenderer } from '@machobear/design-system'
import { useListingData } from '../../context/listing-data'

export const ImportedBadge = () => {
  const { sourceName, sourceAbbreviation = '' } = useListingData()

  return (
    <TooltipRenderer
      id="imported-listing-tag-tooltip"
      tooltip={
        <Text size="small" weight="medium">
          <Trans
            i18nKey="l.listing.imported.tag.tooltip.text"
            values={{ sourceName, tag: sourceAbbreviation }}
          >
            This listing is imported from {{ sourceName }} ({{ sourceAbbreviation }}).
          </Trans>
        </Text>
      }
    >
      {({ triggerProps }) => (
        <Box {...triggerProps} aria-label="External source tag">
          <Badge tone="info">{sourceAbbreviation}</Badge>
        </Box>
      )}
    </TooltipRenderer>
  )
}
